import { DEFAULTS } from "./defaults.js";
import { getTextButtons } from "./getTextButtons.js";
import { lineSpacing } from "./tiptap.js";
import { LINE_SPACING_TYPE } from "./types.js";
const pluginLineSpacing = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINE_SPACING_TYPE,
    textButtons: getTextButtons(),
    tiptapExtensions: [lineSpacing]
  };
};
export {
  pluginLineSpacing
};
//# sourceMappingURL=editor.js.map
